import {SERVICE_ENDPOINT} from "../const";
import {formDataInstance, gatewayInstance} from "../axiosInstance";


export const chargesByCustomer = async (customerId) => {
    try {
        const response = await gatewayInstance.get(
            `${SERVICE_ENDPOINT.TRANSPORT}/stkChargeTypeView/customercharge/${customerId}`,
        );

        return response.data.map((item) => ({
            key: item.id,
            text: item.text,
            value: item.id,
        }));
    } catch (e) {
        console.error("chargesByCustomer error:", e?.message || e);
    }
};

export const uploadChargeBulkData = async (data) => {
      return await formDataInstance.post(
        `${SERVICE_ENDPOINT.FINANCE}/job-charge-creation/excelUpload`,
        data,
    );
};

export const searchBulkJobCharge = async (data) => {
    try {
        console.log("searchBulkJobCharge", data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.FINANCE}/job-charge-creation/searchJobCharges`,
            data,
        );
        console.log("BulkJobCharge res", response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const JobChargeDetailsById = async (data) => {
    try {
        console.log("req jobChargeDetailsById", data);
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.FINANCE}/job-charge-creation/searchJobChargeDetails?jobChargeHeaderId=${parseInt(data, 10)}`
        );
        console.log("response JobChargeDetailsById", response);
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const downloadBulkTemplate = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/report/templateDownload`,
            null,
            {
                params: { templateTypeKeyNo: data },
                responseType: 'blob',
            }

        );
        const contentDisposition = response.headers['content-disposition'];
        let fileName = 'bulk upload template.xlsx';
        if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename=(.+)/);
            if (filenameMatch && filenameMatch[1]) {
                fileName = filenameMatch[1];
            }
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

    } catch (e) {
        console.error(e);
    }
};


